import React from 'react'
import { Link } from '@inertiajs/react'
import { cx } from '@/lib/utils'
import styles from './MobileNavLink.module.scss'

interface MobileNavLinkProps {
  href: string
  children: React.ReactNode
  active?: boolean
  onClick?: () => void
}

export const MobileNavLink: React.FC<MobileNavLinkProps> = ({
  href,
  children,
  active = false,
  onClick,
}) => (
  <Link
    href={href}
    className={cx(styles.link, active && styles.active)}
    onClick={onClick}
  >
    {children}
  </Link>
)
